import { FunctionComponent } from "react";
import * as Styled from "./styles";
import { tokens } from "@manifesthhqinc/ui-library";

interface NumberIconProps {
  iconNumber: string;
  color?: string;
  backgroundColor?: string;
  inverted?: boolean;
}

const NumberIcon: FunctionComponent<NumberIconProps> = ({
  iconNumber = "1",
  backgroundColor = tokens.color.brand[700],
  color = "#fff",
  inverted = false,
}) => {
  return (
    <Styled.NumberIconDiv $backgroundColor={backgroundColor} $color={color} $inverted={inverted}>
      <span>{iconNumber}</span>
    </Styled.NumberIconDiv>
  );
};

export default NumberIcon;
